module.exports = __webpack_public_path__ + "static/media/3Circle_ME.405565fd.svg";